"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveLabel = void 0;

var _formatLabel = require("../helpers/formatLabel");

var resolveLabel = function resolveLabel(field) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var formatter = options && options.optionalLabelFormatter ? options.optionalLabelFormatter : _formatLabel.formatOptionalLabel;
  return field.optional ? formatter(field.label, field.name) : field.label;
};

exports.resolveLabel = resolveLabel;